import {ICharacteristic} from '../services/interfaces/ICharacteristics'

export const getCharacteristicTranslation = (characteristic: ICharacteristic, language: string) =>
  language === 'en' && characteristic.value_en ? characteristic.value_en : characteristic.value_es
